<template lang="html">
<div class="">
  <div class="bg-white hover:border-blue-700 room-card opacity-90 hover:opacity-100 rounded-md border"
       :class="compact ? 'py-2 px-2' : 'py-4 px-4'">
    <div class="flex justify-between items-center">
      <div>
        <span :class="compact ? 'text-base font-medium' : 'text-lg font-bold inline-block leading-4 max-w-[16rem] truncate'"
          data-e2e="room_name" >
          {{ room.name }}
          <div class="text-red-500" v-if="room.is_suspended">Paused</div>
        </span>
        <span class="text-xs text-gray-600" v-if="compact">
          {{ dateToAmericanFormat(room.scheduled_at) }}
        </span>
        <a rel="nofollow" data-method="delete" :href="'/rooms/' + room.key"
           class="ml-2 text-gray-500 hover:bg-transparent rounded-md hover:text-red-500 text-sm"
           v-if="!room.hidden_at">
          Hide
        </a>
        <a rel="nofollow" data-method="delete" :href="'/rooms/' + room.key"
           class="ml-2 text-gray-500 hover:bg-transparent rounded-md hover:text-red-500 text-sm"
           v-if="room.hidden_at">
          Unhide
        </a>
      </div>
      <div v-if="!hidden" class="font-medium text-blue-600 hover:text-blue-700 space-x-2">
        <a class="hover:underline" :href="'/rooms/' + room.key" data-e2e="start_session_test" data-turbolinks="false" v-if="currentBrowser() === 'chrome'">
          Setup
        </a>
        <button class="btn-disabled" :data-tippy-content="currentBrowser() === 'chrome' ? '' : 'For the moment you can only host sessions on Google Chrome'" v-else>
          Setup
        </button>
      </div>
    </div>
    <p class="mt-1 text-sm leading-5 text-gray-500">
      <span v-if="!compact">
        <span v-if="room.activated">
          Activated until -
        </span>
        <span v-else>
          Not activated -
        </span>
        <span> {{ dateToAmericanFormat(room.scheduled_at) }} - {{ room.city.name }} </span>
      </span>
      <div v-if="!compact">
        <span>{{ room.city.name }} </span>
        <span>
          <img class="w-4 h-4 inline-block mr-1" :src="'/images/flags/'+room.city.iso_alpha_2_code+'.svg'"
               alt="Country flag for city"/>
        </span>
      </div>
    </p>
    <!-- hidden compact view -->
    <div v-if="hidden" class="flex items-center space-x-2 pt-3 h-8">
      <div class="flex flex-shrink-0 -space-x-1">
        <div v-for="(p,i) in this.participants.slice(0,4)" class="h-8 w-8 rounded-full ring-2 ring-white">
            <img :title="p.name" class="w-full" :src="'https://beta.milan.mictap.com/siglas?label='+ siglasFromName(p.name) +'&bg=0000FF&fg=FFFFFF&size=100'" alt="" />
        </div>
      </div>
      <span v-if="this.participants.length > 4"
            class="flex-shrink-0 text-xs leading-5 font-medium">+{{ this.participants.length - 4 }}</span>
    </div>
    <!-- not hidden view -->
    <div v-if="!hidden" class="sm:grid sm:grid-cols-2 sm:gap-4 items-end">
      <div class="flex items-center">
        <div class="flex flex-shrink-0 -space-x-1 h-8 items-end">
          <div v-for="(p,i) in this.participants.slice(0,4)"
               :class="compact ? 'h-6 w-6' : 'h-8 w-8'"
               class="rounded-full ring-2 ring-white mt-2">
            <img :title="p.name" class="w-full" :src="'https://beta.milan.mictap.com/siglas?label='+ siglasFromName(p.name) +'&bg=0000FF&fg=FFFFFF&size=100'" alt="" />
          </div>
          <span v-if="this.participants.length > 4"
                class="flex-shrink-0 text-xs leading-5 font-medium ml-2">+{{ this.participants.length - 4 }}</span>
          <span v-if="this.participants.length == 0"
                class="flex-shrink-0 text-xs font-medium text-gray-500">No participants invited</span>
        </div>
      </div>

        <a rel="nofollow" @click="showParticipantsModal = true"
           class="block text-blue-200 hover:bg-transparent rounded-md hover:text-blue-500 cursor-pointer underline text-right"
           data-e2e="manage_test">
          Manage
        </a>
      </div>
    </div>
    <!-- MARK: Participants modal -->
    <modal :showModal="showParticipantsModal" @close="showParticipantsModal = false" classSize="sm:max-w-2xl">
      <manage-participants @close-modal="showParticipantsModal = false"
                           :room="room" :roles="roles" v-bind:participants.sync="participants"
                           :is-in-trial="isInTrial" @on-request-load-participants="loadParticipants"> </manage-participants>
    </modal>
    <!-- MARK END -->
  </div>

</template>
<script>
import axios from 'axios';
import tippy from 'tippy.js';

export default {
  data() {
    return {
      errorName: null,
      errorEmail: null,
      roomLimit: 20,
      participants: [],
      showParticipantsModal: false,
      token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      selectedParticipant: {},
      // for recommended participants
      favoriteParticipants: [],
    }
  },
  props: {
    time_zone: {
      type: String,
      required: true,
    },
    room: {
      type: Object,
      required: true,
      validator: function (value) {
        return value.name // check if it has an id
      }
    },
    roles: {
      type: Array
    },
    isInTrial: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    hidden: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    unsavedParticipants() {
      return this.participants.filter(p => p.status == 'not_saved');
    }
  },
  methods: {
    loadFavoriteParticipants: function () {
      axios.get('/participants/favorite').then(response => {
        this.favoriteParticipants = response.data;
        this.favoriteParticipants.forEach(p => {
          p.invitationSent = false;
          p.is_allowed_sharing = false;
        });
      }).catch(err => {
        console.log(err);
      })
    },
    loadParticipants: function () {
      axios.get('/rooms/' + this.room.id + '/participants').then(response => {
        this.participants = response.data;
        this.participants.forEach(p => {
          p.invitationSent = false;
          p.is_allowed_sharing = p.allow_sharing_until != null && Date.parse(p.allow_sharing_until) > Date.now();
        });
      }).catch(err => {
        console.log(err);
      })
    },
    dateToAmericanFormat(date) {
      if (date) {
        const formattedDate = new Date(date).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          timeZone: this.time_zone,
        });
        return formattedDate;
      }
    },
    siglasFromName(name){
      if (name){
        return name.trim().split(" ").map(a => a[0].toUpperCase()).join("").slice(0,2)
      } else {
        return ""
      }
    }
  },
  mounted() {
    this.loadParticipants()
    // do not show tippy on mobile
    if (window.innerWidth > 768) tippy('[data-tippy-content]',{ allowHTML: true, });
  }
}

// not implemented in Vue
// var calendarEl = document.getElementById('calendar');
// var calendar = new FullCalendar.Calendar(calendarEl, {
//   height: 550,
//   initialView: 'dayGridMonth',
//   events: [
//       <% @rooms.each do |room| %>
//              { title: "<%= room.name %>",
//             start: "<%= room.scheduled_at.strftime("%FT%T%:z") %>",
//             end: "<%= (room.scheduled_at + 1.hour ).strftime("%FT%T%:z") %>",
//             url: '#' },
//       <% end %>
//     ]
// });
// calendar.render();
</script>
<style lang="scss">
  .room-card:hover {
  background-color: rgb(247 247 255)
  }

</style>
